import { useFeatureGates } from "../../cof-feature-gates/hooks";
import { CofConfigId, OrgnanizationType } from "../../gql-generated/types";
import { type ApolloResult } from "../models";

import { useOrganizationMetadata } from "./useOrganizationMetadata";
import { useSelectedLensCentralOrganizationNotIncludesCamkitOrgs } from "./useSelectedLensCentralOrganizationNotIncludesCamkitOrgs";
import { useSelectedOrganization } from "./useSelectedOrganization";

export const useShouldShowAdsAvailability = (): ApolloResult<{
    shouldShowAdsAvailability: boolean;
}> => {
    const { configs, loading: configsLoading, error: configsError } = useFeatureGates();
    const selectedOrgV1 = useSelectedLensCentralOrganizationNotIncludesCamkitOrgs();

    const isMyLensesOrgsV2Enabled = configs[CofConfigId.MyLensesOrgsV2].enabled;
    const selectedOrgV2 = useSelectedOrganization();

    const selectedOrg = isMyLensesOrgsV2Enabled ? selectedOrgV2 : selectedOrgV1;

    const {
        organizationMetadata,
        loading: organizationMetadataLoading,
        error: organizationMetadataError,
    } = useOrganizationMetadata(selectedOrg?.id ?? "", !selectedOrg || !configs[CofConfigId.MyLensesQara].enabled);

    return {
        loading: configsLoading || organizationMetadataLoading,
        error: configsError ?? organizationMetadataError,
        shouldShowAdsAvailability:
            configs[CofConfigId.MyLensesQara].enabled && organizationMetadata?.type === OrgnanizationType.Enterprise,
    };
};
